import axios from "axios";
import { BASE_URL } from "../constants";


const apiImageInstance = axios.create({
	baseURL: BASE_URL,
	headers: {
		'Content-Type': 'multipart/form-data',
	}
});

apiImageInstance.interceptors.response.use(
	response => {
		return response
	},

	function (error) {
		const originalRequest = error.config

		if (error.response.status === 401) {
			return Promise.resolve(error.response)
		} else {
			return Promise.resolve(error.response)
		}
	}
);


export default apiImageInstance;